import React, {useState} from "react";
import {useForm, SubmitHandler} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "./Input";
import axios from "axios";
import styles from "./Form.module.scss";
import cn from "classnames";
import Button from "../Button/Button";
import {Row, Col} from "react-bootstrap";
import {IFormValuesFeedback} from "../../types/formTypes";
import {useModal} from "../../context/ModalContext";
import {useResponseStatus} from "../../context/ResponseStatusContext";
import docsData from "../../data/docsData.json";

// Define validation schema using Yup
const dataSchema = yup.object().shape({
    surname: yup.string().required("Фамилия обязательное поле"),
    firstName: yup.string().required("Имя обязательное поле"),
    patronymic: yup.string().required("Отчество обязательное поле"),
    phoneNumber: yup.string().required("Номер телефона обязательное поле")
        .matches(/^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, "Некорректный формат номера"),
    comment: yup.string(),
});

interface FormProps {
    closeModal?: () => void;
    className?: string;
}

const FormFeedback: React.FC<FormProps> = ({closeModal, className}) => {
    const {register, handleSubmit, formState: {errors}} = useForm<IFormValuesFeedback>({
        resolver: yupResolver(dataSchema),
    });

    const {openModalC} = useModal();
    const {setResponseStatus, setFormType} = useResponseStatus();
    const [status, setStatus] = useState<'pending' | 'error' | 'success' | 'initial'>('initial');

    const onSubmit: SubmitHandler<IFormValuesFeedback> = async (data) => {
        setStatus('pending'); // Начинаем отправку формы
        setFormType('feedback');

        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        try {
            const response = await axios.post("./php/sendmail.php", formData, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            if (response.data.result === "success") {
                setStatus('success');
                setResponseStatus(true);
                setTimeout(openModalC, 200);
            } else {
                setStatus('error'); // Ошибка
                // console.error("Ошибка:", response.data.message || "Произошла ошибка.");
                setResponseStatus(false);
                setTimeout(openModalC, 200);
            }
            closeModal?.();

        } catch (error) {
            setStatus('error'); // Ошибка
            // console.error("Ошибка:", error);
            setResponseStatus(false);
            setTimeout(openModalC, 200);
            closeModal?.();
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className={cn(styles.form, className)}>
            <Row className="g-4 align-items-end">
                <Col sm={6} md={4}>
                    <Input
                        label="Фамилия*"
                        name="surname"
                        placeholder="Иванов"
                        register={register}
                        className={className}
                        errorMessage={errors.surname?.message}
                    />
                </Col>
                <Col sm={6} md={4}>
                    <Input
                        label="Имя*"
                        name="firstName"
                        placeholder="Иван"
                        register={register}
                        className={className}
                        errorMessage={errors.firstName?.message}
                    />
                </Col>
                <Col sm={6} md={4}>
                    <Input
                        label="Отчество*"
                        name="patronymic"
                        placeholder="Иванович"
                        register={register}
                        className={className}
                        errorMessage={errors.patronymic?.message}
                    />
                </Col>
                <Col sm={6} md={4}>
                    <Input
                        label="Телефон*"
                        name="phoneNumber"
                        placeholder="+7 (900) 000-00-00"
                        register={register}
                        className={className}
                        mask="+7 (999) 999-99-99"
                        errorMessage={errors.phoneNumber?.message}
                    />
                </Col>
                <Col sm={6} md={8}>
                    <Input
                        label="Комментарий"
                        name="comment"
                        register={register}
                        className={className}
                    />
                </Col>
                <Col md={12}>
                    <Button type="submit"
                            classButton="redButton"
                            disabled={status === 'pending'}
                    >
                        {status === 'pending' ? 'Отправка...' : 'Задать вопрос'}
                    </Button>
                </Col>
                <Col xs={12} md={8} className="text-white text-opacity-75">
                    Нажимая «Задать вопрос», я соглашаюсь <a
                    href={`${window.location.origin}/${docsData[2].link.replace(/^\.?\//, '')}`} target="_blank">
                    {docsData[2].title.toLowerCase()}
                </a>
                    , а также что ознакомлен с <a href={`${window.location.origin}/${docsData[1].link.replace(/^\.?\//, '')}`}
                                                  target="_blank">{docsData[1].title.toLowerCase()}
                </a>
                </Col>
            </Row>
        </form>
    );
};

export default FormFeedback;
